import { useMediaQuery } from "@mui/material";
import MultiExchangeWeb from "./MultiExchangeWeb";
import MultiExchangeMobile from "./MultiExchangeMobile";


const MultiExchange = () => {
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  return isSmallScreen ? <MultiExchangeMobile /> : <MultiExchangeWeb />;
};

export default MultiExchange;
